const PAYMENT_TYPE_CODE_BY_METHOD = {
  cash: 'CASH',
  card: 'ONLN',
  online: 'ONLN',
};

export const resolveSyrvePaymentType = (paymentTypes, paymentMethod, venueName = 'organization') => {
  const desiredCode = PAYMENT_TYPE_CODE_BY_METHOD[paymentMethod];

  if (!desiredCode) {
    throw new Error(`Unsupported payment method: ${paymentMethod}`);
  }

  const selectedPayment = (paymentTypes || []).find(
    (paymentType) => paymentType.code === desiredCode && !paymentType.isDeleted
  );

  if (!selectedPayment) {
    const availableCodes = (paymentTypes || [])
      .filter((paymentType) => !paymentType.isDeleted)
      .map((paymentType) => `${paymentType.code || 'NO_CODE'}:${paymentType.paymentTypeKind || 'NO_KIND'}`)
      .join(', ');

    throw new Error(
      `Payment type ${paymentMethod} (${desiredCode}) not configured in POS for ${venueName}. Available active payment types: ${availableCodes || 'none'}`
    );
  }

  return {
    paymentTypeId: selectedPayment.id,
    paymentTypeKind: selectedPayment.paymentTypeKind,
    paymentTypeCode: selectedPayment.code,
    paymentTypeName: selectedPayment.name,
  };
};
